// extracted by mini-css-extract-plugin
export default {"pdfMobilePreview":"FormatChecker_pdfMobilePreview__XfFOg","pdfDesktopPreview":"FormatChecker_pdfDesktopPreview__YZePt"};